var UniqueContainerId = /** @class */ (function () {
    function UniqueContainerId(id, type) {
        this.id = id;
        this.type = type;
    }
    UniqueContainerId.prototype.toString = function () {
        return "".concat(this.id, ":").concat(this.type);
    };
    UniqueContainerId.prototype.equals = function (other) {
        return other.id === this.id && other.type === this.type;
    };
    UniqueContainerId.fromString = function (id) {
        var parts = id.split(":");
        return new UniqueContainerId(parts[0], UniqueContainerId.toTreeItemType(parts[1]));
    };
    UniqueContainerId.fromObject = function (uniqueId) {
        return new UniqueContainerId(uniqueId.id, uniqueId.type);
    };
    UniqueContainerId.fromContainerTreeData = function (containerData) {
        return new UniqueContainerId(containerData.id, containerData.containerType);
    };
    UniqueContainerId.toTreeItemType = function (type) {
        return parseInt(type);
    };
    return UniqueContainerId;
}());
export { UniqueContainerId };
//# sourceMappingURL=UniqueContainerId.js.map